import React from 'react';
import { COLORS } from '../../styles/tokens';

// Rund tilbakeknapp øverst på sider uten toppmeny (mobil)
export default function RoundBackButton({ onClick, label = 'Tilbake' }) {
  return (
    <button type="button" onClick={onClick} aria-label={label} style={styles.btn}>
      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" aria-hidden="true">
        <path d="M10 2L2 10l8 8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}

const styles = {
  btn: {
    width: 44, height: 44, borderRadius: '50%', border: `1px solid ${COLORS.border}`,
    background: COLORS.white, color: COLORS.textDark, cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
};
